<template>
  <li :class="classStyle" v-if="checkExpireDate()">
    <router-link :to="{path: linkValue}" v-if="internalLink">
      <img :src="imgSrc ? 'https://apps.odenserundt.dk/media/images/480/'+imgSrc : '/img/placeholder.png'" class="theme-box-img" :alt="'Billede af '+childData.title" :aria-label="'Billede af '+childData.title"/>
      <div class="theme-box-text-div">
        <h3 class="theme-box-text">{{ childData.title }}</h3>
      </div>
    </router-link>
    <a :href="linkValue" v-else>
      <img :src="imgSrc ? 'https://apps.odenserundt.dk/media/images/480/'+imgSrc : '/img/placeholder.png'" class="theme-box-img" :alt="'Billede af '+childData.title" :aria-label="'Billede af '+childData.title"/>
      <div class="theme-box-text-div">
        <h3 class="theme-box-text">{{ childData.title }}</h3>
      </div>
    </a>

    <!-- <span class="like-icon" role="button" :aria-label="[isLiked ? 'Fjern '+childData.title+' fra favoritter' : 'Tilføj '+childData.title+' til favoritter']" @click="likeController" tabindex="0">
      <span :class="['material-icons', 'like-icon-i', {'pink-text' : isLiked}]" aria-hidden="true">favorite_border</span>
    </span> -->
  </li>
</template>

<script>

import Dato from '@/assets/Dato.js'
import DataManager from '@/assets/DataManager'
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      linkValue: '',
      internalLink: true,
      imgSrc: false,
      itemId: '',
      isLiked: false,
      likeOptions: false,
    }
  },
  props: {
    childData: {
      type: Object,
      required: true
    },
    tagList: {
      type: Object
    },
    searchDataExpanded: {
      type: Array
    },
    isGroupPage: {
      type: Boolean,
    }
  },
  computed: {
    classStyle() {
      return this.isGroupPage ? 'col-lg-6 col-md-6 col-sm-4 col-6 theme-box' : 'col-lg-2 col-md-4 col-sm-4 col-6 theme-box';
    },
  },
  watch: {
    childData() {
      this.createData();
    }
  },
  created() {
    this.createData();
  },
  methods: {
    createData() {
      if(this.$props.childData.type == 'link') {
        if(this.$props.childData.link.indexOf('odenserundt.dk') != -1) {
          //console.log('Internt', this.linkValue);
          let split = this.$props.childData.link.split('odenserundt.dk');
          this.linkValue = split[1];
        }
        else {
          this.internalLink = false;
          this.linkValue = this.$props.childData.link;
        }
        this.itemId = this.childData.id;
        this.likeOptions = {type: this.childData.type, id: this.childData.id, name: this.childData.title, http: this.childData.link, img: this.childData.media};
      }
      if(this.$props.childData.type == 'group') {
        this.linkValue = '/group/'+this.$props.childData.id;
        this.itemId = this.childData.id;
        this.likeOptions = {type: this.childData.type, id: this.childData.id, name: this.childData.title, img: this.childData.media};
      }
      if(this.$props.childData.type == 'tag') {
        this.linkValue = '/tag/'+this.$props.childData.tags;
        this.itemId = this.childData.tags;
        this.likeOptions = {type: this.childData.type, id: this.childData.tags, name: this.childData.title,};
      }
      if(this.$props.childData.type == 'place') {
        this.linkValue = '/tag/'+this.$props.childData.primary+'/place/'+this.$props.childData.item_id;
        this.likeOptions = {type: this.childData.type, id: this.childData.item_id, name: this.childData.title, tagId: this.childData.primary};
        this.itemId = this.childData.item_id;
      }
      if(Profile.loggedIn) {
        this.isLiked = Profile.checkIfItemIsLiked(this.childData.type, this.itemId);
      }
      this.checkForTempImages();
    },
    likeController() {
      if(Profile.loggedIn) {
        var isLiked = Profile.checkIfItemIsLiked(this.childData.type, this.itemId);
        if(!isLiked) {
          Profile.like(this.likeOptions);
          this.isLiked = true;
        }
        else if(isLiked) {
          var obj = {message: 'Vil du fjerne '+this.childData.title+' fra dine favoritter?', cancelBtnText: 'Nej', btnText: 'Ja', callbackType: 'function', callback: this.unlikeDone};
          EventBus.$emit('openMessageBox', obj);
        }
      }
      else {
        this.$router.push('/login');
      }
    },
    unlikeDone() {
      Profile.unlike(this.childData.type, this.itemId);
      this.isLiked = false;
    },
    checkForTempImages() {
      if(this.$props.childData.type == 'place') {
  			var tempImage = false;
        var itemData = this.searchDataExpanded.find(obj => obj.placeId == this.$props.childData.item_id);
        if(itemData != undefined) {
  				//this.linkValue = '/tag/'+itemData.tagId+'/place/'+this.$props.childData.item_id;
          DataManager.getData([DataManager.newTags+itemData.tagId+'-dk-light.json'], (response) => {
            var item = response[0].data.features.find(obj => obj.id == this.$props.childData.item_id);
  					if(item.properties.prop117 && item.properties.prop108) {
  						if(item.properties.prop117.value != null && item.properties.prop117.value != undefined && item.properties.prop117.value != 0) {
  							var from = new Date(item.properties.prop117.value.from);
  							var to = new Date(item.properties.prop117.value.to);
  							if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()) {
  								this.imgSrc = item.properties.prop108.value[0].src;
  								tempImage = true;
  							}
  						}
  					}
  					if(item.properties.prop25 && !tempImage) {
  						this.imgSrc = item.properties.prop25.value[0].src;
              this.likeOptions.img = item.properties.prop25.value[0].src;
  					}
          });
  			}
  		}
  		if(this.$props.childData.type == 'group' || this.$props.childData.type == 'link') {
  			if(this.$props.childData.media != '' && this.$props.childData.media != 0 && this.$props.childData.media != null && this.$props.childData.media != false) {
  				this.imgSrc = this.$props.childData.media;
  			}
  		}
      else if(this.$props.childData.type == 'tag') {
    		if(this.$props.childData.tags != undefined) {
    			if(this.tagList[this.$props.childData.tags]) {
    				if(this.tagList[this.$props.childData.tags].image) {
    					if(this.tagList[this.$props.childData.tags].image != 0 && this.tagList[this.$props.childData.tags].image != "" && this.tagList[this.$props.childData.tags].image != null && this.tagList[this.$props.childData.tags].image != false) {
                this.imgSrc = this.tagList[this.$props.childData.tags].image;
                this.likeOptions.img = this.tagList[this.$props.childData.tags].image;
    					}
    				}
    			}
    		}
      }
  	},
    checkExpireDate() {
      var expired = false;
			if(this.childData.endDate != false) {
				var itemExpired = Dato.checkExpireDate(this.childData);
				if(itemExpired) {
					expired = false;
				}
				else {
					expired = true;
				}
			}
      return !expired;
    },
  },
}
</script>

<style lang="scss" scoped>

.theme-box, .theme-page-box {
	display: inline-block;
  position: relative;
	padding-left: 5px;
	padding-right: 5px;
	margin-bottom: 10px;
}

/*Landscape - XS*/
@media screen and (max-width: 767px) and (orientation: landscape) {
	.theme-box-text {
		line-height: 12px;
	}
}
/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
	.theme-page-box {
		margin-bottom: 10px;
		padding-left: 10px;
		padding-right: 10px;
	}
}
/*Landscape - LG*/
@media screen and (min-width: 1200px) and (orientation: landscape) {
	.theme-page-box {
		padding-left: 10px;
		padding-right: 10px;
		margin-bottom: 15px;
	}
}
/*Portrait - XS*/
@media screen and (max-width: 767px) and (orientation: portrait) {
	.theme-box-text {
		line-height: 12px;
	}
}

.theme-box-img {
	width: 100%;
  -webkit-filter: grayscale(10%);
  filter: grayscale(10%);
}

.theme-box-text-div {
  height: 40px;
  width: 100%;
  color: #424242 !important;
	padding-left: 3px;
	letter-spacing: 0.5px;
	background-color: #fdfdfd;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
}

.theme-box-text {
	margin: 0px;
	font-size: 14px;
	position: relative;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
}
</style>
